<div class="page-container box-container-users" *ngIf="modelAudit.renderPrincipal">
    <div class="d-flex fd-row justify-space-between section-title-user pb-md-24">
        <div
            class="text-color-secondary-1 d-flex fd-row align-items-center letter-spacing-1 text-size-32 text-md-size-24 text-weight-600">
            <sit-icon class="col-sm d-flex d-md-none" [icon]="Icon.audit_y" [sizeClass]="'icon-size-40'"
                alt="icono de usuario"></sit-icon>
            <sit-icon (click)="navigateToVisor()" class="d-md-flex d-none" [icon]="Icon.previous_page_y"
                alt="Icono boton atrás" [sizeClass]="'icon-size-32'"></sit-icon>
            <span>Auditoría</span>
        </div>
    </div>
    <hr class="mb-1 line-separator d-md-none" />

    <div class="d-flex fd-row">

        <div class="d-flex fd-col width-20 menu-left" *ngIf="selectedFunctionality">
            <mat-label class="text-color-secondary-2 text-weight-500 text-size-18 mb-12">{{ 'Funcionalidad'
                }}</mat-label>
            <ng-container *ngFor="let item of funcionalidades; let i = index">
                <div class="button-radio">
                    <input id="btn-{{item.code}}-{{i}}" name="funcionalidad" class="hidden-radio" type="radio"
                        [value]="item.code" [(ngModel)]="selectedFunctionality" (change)="onSelectFunctionality()" />
                    <label for="btn-{{item.code}}-{{i}}" class="button-label text-size-16">{{ item.name }}</label>
                </div>
            </ng-container>
        </div>

        <div class="d-flex fd-col gap-10-px mb-12 width-80 search-container">
            <mat-tab-group>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <sit-icon class="col-sm d-flex d-md-none mr-05-em" [icon]="Icon.login_user_y" [sizeClass]="'icon-size-24'"
                            alt="icono de usuario"></sit-icon>
                        Funcionario
                    </ng-template>
                    <ng-template matTabContent>
                        <search-audit-user
                            *ngIf="renderTab"
                            [funcionality]="selectedFunctionality"
                            (handleValue)="manageEvent($event)"
                        ></search-audit-user>
                    </ng-template>
                </mat-tab>

                <mat-tab>
                    <ng-template mat-tab-label>
                        <sit-icon class="col-sm d-flex d-md-none mr-05-em" [icon]="Icon.login_user_y" [sizeClass]="'icon-size-24'"
                            alt="icono de usuario"></sit-icon>
                        Id. Registro
                    </ng-template>
                    <ng-template matTabContent>
                        <search-audit-record
                            *ngIf="renderTab"
                            [funcionality]="selectedFunctionality"
                            (handleValue)="manageEvent($event)"
                        ></search-audit-record>
                    </ng-template>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>

<grid-audit-user
    *ngIf="modelAudit.renderGridUser"
    [model]="modelAudit"
    (handleValue)="manageEvent($event)"
></grid-audit-user>

<grid-audit-record
    *ngIf="modelAudit.renderGridRecord"
    [model]="modelAudit"
    (handleValue)="manageEvent($event)"
></grid-audit-record>

<panel-audit-info *ngIf="modelAudit.renderAuditPanel"
    [properties]="propertiesPanelAuditInfo"
    [breadcrumbs]="modelAudit.routes"
    (handleValue)="manageEvent($event)"
></panel-audit-info>
